/**
 * All kind of type constants
 */

/**
 * All possible types of teasers
 */
const TeaserTypes = {
    AD: 'ad',
    ARTICLES: 'articles',
    IFRAME: 'iframe',
    LINKS: 'links',
    SLIDESHOWS: 'slideshows',
    TICKERS: 'tickers',
    VIDEOS: 'videos',
    PLACEHOLDER: 'placeholder',
    BREAKINGNEWS: 'breakingnews',
    SLIDER: 'slider',
    EMBEDS: 'embeds',
    MOST_POPULAR: 'mostPopular',
    LIFESTYLE_QUOTE: 'lifestylequote',
    POPULARITY: 'popularity',
    WIDGET_MOST_COMMENTED: 'widgetMostCommented',
    WIDGET_RECENTLY_COMMENTED: 'widgetRecentlyCommented',
    IGNORE: 'ignore'
};

/**
 * All possible types for content pages
 */
const ContentType = {
    ARTICLE: 'article',
    BREAKINGNEWS: 'breakingnews',
    LIFESTYLE: 'lifestyle',
    TICKER: 'ticker',
    SLIDESHOW: 'slideshow',
    VIDEO: 'video',
    EMBED: 'embed',
    LINK: 'link'
};

/**
 * All section types
 * default
 * category
 * custom
 */
const SectionTypes = ['default', 'category', 'custom'];

/**
 * All possible types of custom sections
 */
const CustomSectionTypes = {
    MOST_POPULAR: 'mostPopular',
    LIFESTYLE_QUOTE: 'lifestylequote'
};

/**
 * All possible types of elements in feed
 */
const ElementTypes = {
    TITLE: 'title',
    LEAD: 'lead',
    CROSSHEAD: 'crosshead',
    HTML_TEXT: 'htmlText',
    IMAGE: 'image',
    QUOTE: 'quote',
    UNORDERED_LIST: 'unordered-list',
    ORDERED_LIST: 'ordered-list',
    SEPARATOR: 'separator',
    VIDEO: 'video',
    EMBED: 'embed',
    AD: 'ad',
    SLIDESHOW: 'slideshow',
    CONTAINER: 'container',
    POLL: 'poll',
    VIDEOCMS: 'videocms',
    AUTHORS: 'authors',
    AGENCIES: 'agencies',
    PUBLISH_DATE: 'publishDate',
    TITLE_HEADER: 'title-header',
    SLIDE_PLACEHOLDER: 'slidePlaceholder',
    TEXT_BLOCK_ARRAY: 'textBlockArray',
    HTML_TEXT_ITEM: 'htmlTextItem',
    INTERNAL_LINK: 'internalLink',
    LIVESTREAM: 'livestream',
    INTERVIEW_SEGMENT: 'interviewSegment',
    LIST: 'list'
};

/**
 * All types of social media providers
 */
const SocialMediaTypes = {
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    TWITTER: 'twitter'
};

/**
 * All types of external video providers
 */
const VideoProviderTypes = {
    YOUTUBE: 'youtube'
};

/**
 * All types of activity content for API request
 */
const ActivityContentType = {
    COMMENT: 'comment',
    CONTENT: 'content'
};

/**
 * api types related constants
 * All api types that could be fail in an error
 */
const ApiTypes = {
    COMMENT: 'Comment',
    SHARE: 'Share',
    BOOKMARK: 'Bookmark'
};

/**
 * All platform types for sharing
 */
const SharePlatformTypes = {
    EMAIL: 'email',
    FACEBOOK: 'facebook',
    WHATSAPP: 'whatsapp'
};

export {
    TeaserTypes,
    ContentType,
    SectionTypes,
    CustomSectionTypes,
    ElementTypes,
    SocialMediaTypes,
    VideoProviderTypes,
    ActivityContentType,
    ApiTypes,
    SharePlatformTypes
};
